import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FullLoaderService } from '../../services/full-loader.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-embedded-loader',
  templateUrl: './embedded-loader.component.html',
  styleUrls: ['./embedded-loader.component.css']
})
export class EmbeddedLoaderComponent implements OnInit, OnDestroy {
  @Input() show: boolean = true;
  @Input() message: string = '';

  private fullLoaderActive: boolean = false;
  private loaderSub?: Subscription;

  constructor(private fullLoaderService: FullLoaderService) {}

  ngOnInit(): void {
    this.loaderSub = this.fullLoaderService.getLoaderStateObservable().subscribe(state => {
      this.fullLoaderActive = state.state;
    });
  }

  ngOnDestroy(): void {
    this.loaderSub?.unsubscribe();
  }

  get isVisible(): boolean {
    return this.show && !this.fullLoaderActive;
  }
}
